import Util from "@/helper/Utility.js";
// import PropsHelper from "@/helper/PropsHelper";
import { ProfileModel } from "@/core/Account/model/AccountModel";
import DatetimeHelper from "@/helper/DatetimeHelper";
import { DateTime } from "luxon";
import CacheHelper from "@/helper/CacheHelper";
import Utility from "@/helper/Utility.js";

export function RegisterModel() {
    this.strIdToken = '';
    this.strFirstname = '';
    this.strLastname = '';
    this.strEmail = '';
    this.strContactNumber = '';
    this.strGender = '';
    this.strBirthDate = ''; // iso format
    this.numTermAndCondition = 1;
    this.numDataPrivacy = 1;
    this.strCountryCode = '66' // default as thai
    this.strCountryName = ''
    this.strProvinceCode = 10 // default as bangkok
    this.strProvinceName = ''
    this.mktEmail = null;
    this.mktSms = null;
    this.mktNoti = null;
    this.mktOption = null;


    this.setIdToken = function (idToken) {
        this.strIdToken = idToken;
    }

    this.setTermsVersion = function (termsVersion) {
        this.numTermAndCondition = termsVersion;
    }

    this.setPrivacyVersion = function (privacyVersion) {
        this.numDataPrivacy = privacyVersion;
    }
    this.setMarketingVersion = function (marketingOption, version) {
        this.mktEmail = marketingOption.email ? version : null;
        this.mktSms = marketingOption.sms ? version : null;
        this.mktNoti = marketingOption.noti ? version : null;
        this.mktOption = marketingOption.sms ? version : null;
    }

    this.setDefault = function () {
        this.strCountryCode = '66'
        this.strGender = 'notspecified'
        this.strProvinceCode = 10
        return this
    }

    // this.setValues = function (obj) {
    //     this.strFirstname = PropsHelper.getStringProp(obj.firstname)
    //     this.strLastname = PropsHelper.getStringProp(obj.lastname)
    //     this.strEmail = PropsHelper.getStringProp(obj.email)
    //     this.strContactNumber = PropsHelper.getStringProp(obj.contact_number)
    //     this.strGender = PropsHelper.getStringProp(obj.gender)
    //     this.strBirthDate = PropsHelper.getStringProp(obj.birthdate)
    // }

    this.getParams = function () {
        var params = {
            id_token: this.strIdToken,
            firstname: this.strFirstname,
            lastname: this.strLastname,
            birthdate: this.strBirthDate,
            gender: this.strGender,
            contact_number: this.strContactNumber,
            email: this.strEmail,
            countrycode: this.strCountryCode,
            countryname: this.strCountryName,
            provincecode: this.strProvinceCode,
            provincename: this.strProvinceName,
            termandcondition: this.numTermAndCondition,
            dataprivacy: this.numDataPrivacy,
            mktoption_email: this.mktEmail,
            mktoption_sms: this.mktSms,
            mktoption_notification: this.mktNoti,
            marketingOption: this.mktOption,
        };

        // return Util.cleanObjectEmptyStr(params);
        return params
    }
}

RegisterModel.prototype.setCache = function () {
    let cache = new CacheHelper("local")
    cache.setCache("register_form", this)
}

RegisterModel.prototype.loadCache = function () {
    let cache = new CacheHelper("local")
    let json = cache.getCache("register_form")
    // console.log(json)
    if (json != null) {
        // set values
        this.strFirstname = json?.strFirstname  ?? '';
        this.strLastname = json?.strLastname ?? '';
        if (!Utility.isEmptyStr(json?.strBirthDate ?? '')) {
            this.strBirthDate = json?.strBirthDate
        }
        this.strGender = json?.strGender ?? 'notspecified'
        this.strEmail = json?.strEmail ?? ''
        this.strContactNumber = json?.strContactNumber ?? '' // without country code
        this.strCountryCode = json?.strCountryCode ?? '66' // default as thai
        this.strCountryName = json?.strCountryName ?? 'Thailand' // default as thai
        this.strProvinceCode = json?.strProvinceCode ?? ''
        this.strProvinceName = json?.strProvinceName ?? ''

        // console.log(this)
    }
    // clear cache
    cache.removeCache("register_form")
}

export function RegisterModelBuilder() {
    this.model = new RegisterModel().setDefault()
}

/**
 *
 * @returns {import("@/types/RegisterModel.d").RegisterModel}
 */
RegisterModelBuilder.prototype.create = function () {
    return this.model
}

/**
 *
 * @param {import("@/types/AccountType.d").UserAccountProfile} dict
 * @returns {RegisterModelBuilder}
 */
RegisterModelBuilder.prototype.setValuesFromUser = function (dict) {

    this.model.strFirstname = dict.firstName || '';
    this.model.strLastname = dict.lastName || '';
    if (dict.birthDate != null) {
        this.model.strBirthDate = DatetimeHelper.unixTimestampToISODate(dict.birthDate)
    }
    this.model.strGender = dict.gender || 'notspecified'
    this.model.strEmail = dict.email || ''
    this.model.strContactNumber = dict.contactNumber || ''
    this.model.strCountryCode = dict.countryCode.toString() || '66' // default as thai
    this.model.strCountryName = dict.countryName || 'Thailand' // default as thai
    this.model.strProvinceCode = dict.provinceCode || ''
    this.model.strProvinceName = dict.provinceName || ''

    return this
}
/**
 *  convert register model to profile model
 * @param {import("@/core/Account/model/AccountModel").ProfileModel} profile
 * @param {RegisterModel} dict
 * @returns {import("@/core/Account/model/AccountModel").ProfileModel}
 */

RegisterModelBuilder.prototype.getUpdateModel = function (profile, dict) {
    let obj = dict.getParams()


    // prepare model
    let model = new ProfileModel({})
    // set manual
    model.userId = profile.userId
    model.firstName = obj.firstname
    model.lastName = obj.lastname
    if (obj.birthdate != null) {
        // validate date
        let dt = DateTime.fromISO(obj.birthdate)
        if (dt.isValid) {
            model.birthDate = DatetimeHelper.getUnixTimestampFromISODate(obj.birthdate)
        } else {
            model.birthDate = profile.birthDate // set original
        }
    }
    // model.birthDate = obj.birthdate
    model.gender = obj.gender
    model.email = obj.email
    model.contactNumber = obj.contact_number
    model.countryCode = obj.countrycode
    model.countryName = obj.countryname
    model.provinceCode = obj.provincecode
    model.provinceName = obj.provincename

    return Util.cleanObjectEmptyStr(model)
}
